import { all, fork } from "redux-saga/effects";

import AuthSaga from "./auth/login/saga";
import LayoutSaga from "./layout/saga";
import ProfileSaga from "./auth/profile/saga";
import biboardSaga from "./daily-dashboard/saga";
import bookingdataSaga from "./booking-data/saga";
import dailyboardSaga from "./bi-dashboard/saga";

//public







export default function* rootSaga() {
  yield all([
    //public
    // fork(AuthSaga),
    // fork(ProfileSaga),
    fork(LayoutSaga),
    // fork(dailyboardSaga),
    // fork(biboardSaga),
    // fork(bookingdataSaga),
  ]);
}
